import { common } from '@ocean/ui'
import { Wrapper } from './NavControlGroup.styled'

const { Scrollbars } = common

const NavControlGroup: React.FC = ({ children }) => {
  return (
    <Scrollbars>
      <Wrapper>{children}</Wrapper>
    </Scrollbars>
  )
}

export default NavControlGroup
